import classApi from '@/api/class'

const classes={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    sorter:{},
    schools:[],
    lessons:[],
    rooms:[],
    teachers:[],
    editClass:{},
    changeTeachers:[],
    transClassTeam:[]
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setSchools:(state,schools)=>{
      state.schools=schools
    },
    setLessons:(state,lessons)=>{
      state.lessons=lessons
    },
    setRooms:(state,rooms)=>{
      state.rooms=rooms
    },
    setTeachers:(state,teachers)=>{
      state.teachers=teachers
    },
    ClearRooms:(state)=>{
      state.rooms=[]
    },
    ClearTeachers:(state)=>{
      state.teachers=[]
    },
    editClass:(state,classes)=>{
      state.editClass=classes
    },
    setChangeTeachers:(state,teachers)=>{
      state.changeTeachers=teachers
    },
    setTransClassTeam:(state,team)=>{
      state.transClassTeam=team
    }
  },
  actions:{
    async GetClassList({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await classApi.getClassList(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },classes){
      try{
        if(classes.id){
          await classApi.updateClass(classes)          
        }else{
          await classApi.createClass(classes)
        }
        commit('editClass',{})
        await dispatch('GetClassList',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async DeleteClass({ dispatch,state },classes){
      await classApi.deleteClass(classes.id)
      await dispatch('GetClassList',state.pagination)
    },
    async GetSchools({ commit }){
      const res=await classApi.getSchools()
      commit('setSchools',res.result.items)
    },
    async GetLessons({ commit }){
      const res=await classApi.getLessons()
      commit('setLessons',res.result.items)
    },
    async GetRoomForClass({commit},input){
      const res=await classApi.getRoomForClass(input)
      commit('setRooms',res.result.items)
    },
    async GetTeacherForClass({commit},input){
      const res=await classApi.getTeacherForClass(input)
      commit('setTeachers',res.result.items)
    },
    async CloseClass({dispatch,state},input){
      await classApi.closeClass(input)
      await dispatch('GetClassList',state.pagination)
    },
    async GetClass({commit},input){
      const res=await classApi.getClass(input)
      commit('editClass',res.result)
    },
    async DeleteStudent({ commit },id){
      commit
      await classApi.deleteStudent(id)
    },
    async RecordLesson({ commit },input){
      commit
      await classApi.recordLesson(input)
    },
    async GetSchedulerItems({ commit },input){
      commit
      const res=await classApi.getSchedulerItems(input)
      return res.result
    },
    async FinishClassTeam({dispatch,state},input){
      await classApi.finishClassTeam(input)
      await dispatch('GetClassList',state.pagination)
    },
    async CreateTeam({commit,dispatch,state},input){
      await classApi.createTeam(input)
      commit('editClass',{})
      await dispatch('GetClassList',state.pagination)
    },
    async GetTeacherForTeam({ commit },input){
      const res=await classApi.getTeacherForTeam(input)
      commit('setChangeTeachers',res.result.items)
    },
    async ChangeTeacher({commit},input){
      commit
      await classApi.changeTeacher(input)
    },
    async Deposit({commit},input){
      commit
      await classApi.deposit(input)
    },
    async GetTransClassTeam({commit},input){
      const res=await classApi.getTransClassTeam(input)
      commit('setTransClassTeam',res.result.items)
    },
    async TransClassTeam({commit},input){
      commit
      await classApi.transClassTeam(input)
    }
  }
}
export default classes